import { PartnerSettingsPanel } from "@/components/partner/PartnerSettingsPanel";

const PartnerSettings = () => <PartnerSettingsPanel />;

export default PartnerSettings;
